var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4759 9.70379C15.8672 8.99293 15.5905 8.37689 15.5905 7.33031V6.97446C15.5905 5.61063 15.2766 4.7319 14.5942 3.85318C13.5423 2.48851 11.7716 1.66602 10.0382 1.66602H9.96445C8.26743 1.66602 6.55219 2.45074 5.48213 3.76002C4.76241 4.65637 4.41207 5.57286 4.41207 6.97446V7.33031C4.41207 8.37689 4.15367 8.99293 3.52671 9.70379C3.06539 10.2275 2.91797 10.9006 2.91797 11.6291C2.91797 12.3584 3.15732 13.0492 3.63769 13.6106C4.26465 14.2837 5.15002 14.7135 6.05443 14.7881C7.36384 14.9375 8.67325 14.9938 10.0017 14.9938C11.3293 14.9938 12.6388 14.8998 13.949 14.7881C14.8526 14.7135 15.738 14.2837 16.3649 13.6106C16.8445 13.0492 17.0846 12.3584 17.0846 11.6291C17.0846 10.9006 16.9372 10.2275 16.4759 9.70379Z",
    fill: "url(#paint0_linear_4464_6095)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.6754 16.0238C11.2588 15.9348 8.72035 15.9348 8.30375 16.0238C7.94762 16.106 7.5625 16.2974 7.5625 16.717C7.58321 17.1173 7.81759 17.4707 8.14225 17.6948L8.14142 17.6956C8.56133 18.0229 9.05412 18.2311 9.5701 18.3058C9.84507 18.3435 10.125 18.3418 10.4099 18.3058C10.9251 18.2311 11.4179 18.0229 11.8378 17.6956L11.8369 17.6948C12.1616 17.4707 12.396 17.1173 12.4167 16.717C12.4167 16.2974 12.0316 16.106 11.6754 16.0238Z",
    fill: "url(#paint1_linear_4464_6095)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4464_6095",
    x1: 17.0846,
    y1: 1.66602,
    x2: 1.13031,
    y2: 12.3157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4464_6095",
    x1: 12.4167,
    y1: 15.957,
    x2: 9.42945,
    y2: 19.7889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/Bell-icon.ec9e1da8fcdb58d14f93d9a91ff4375e.svg";
export { ForwardRef as ReactComponent };